import { Faqs } from '@/services/dataTypes';

interface Props {
    faq: Faqs;
    index: number;
}

const MerchantFaqsAccordion = ({ faq, index }: Props) => {
    return (
        <details className="group bg-white border border-slate-100 rounded-2xl overflow-hidden transition-all duration-300 open:border-[#D61C4E]/25 open:shadow-[0_4px_20px_-4px_rgba(214,28,78,0.12)]">

            <summary className="flex items-center justify-between gap-4 px-5 py-4 cursor-pointer list-none select-none focus:outline-none">

                {/* Index + question */}
                <div className="flex items-center gap-3 min-w-0">
                    <span className="shrink-0 w-6 h-6 rounded-lg bg-[#D61C4E]/8 flex items-center justify-center">
                        <span className="text-[10px] font-black text-[#D61C4E] tabular-nums">
                            {String(index + 1).padStart(2, '0')}
                        </span>
                    </span>
                    <span className="text-[13px] font-bold text-slate-800 leading-snug group-open:text-[#D61C4E] transition-colors">
                        {faq.question}
                    </span>
                </div>

                {/* Chevron */}
                <span className="shrink-0 w-6 h-6 rounded-full bg-slate-50 border border-slate-100 flex items-center justify-center group-open:bg-[#D61C4E] group-open:border-[#D61C4E] transition-all duration-300">
                    <svg
                        className="w-3 h-3 text-slate-400 group-open:text-white transition-all duration-300 group-open:rotate-180"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                    </svg>
                </span>
            </summary>

            {/* Answer */}
            <div className="px-5 pb-4 pt-1 border-t border-slate-100">
                <p className="text-[13px] text-slate-500 leading-relaxed font-medium pl-9">
                    {faq.answer}
                </p>
            </div>
        </details>
    );
};

export default MerchantFaqsAccordion;
